'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_IncotermData(incoterm, location) {
  this.BA = null;
  this.BB = null;
  this.BA = incoterm;
  this.BB = location;
}
export { $c_Lapp_data_IncotermData as $c_Lapp_data_IncotermData };
$p = $c_Lapp_data_IncotermData.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_IncotermData;
/** @constructor */
function $h_Lapp_data_IncotermData() {
}
export { $h_Lapp_data_IncotermData as $h_Lapp_data_IncotermData };
$h_Lapp_data_IncotermData.prototype = $p;
$p.z = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lapp_data_IncotermData)) {
    if ((this.BA === x$0.BA)) {
      var x = this.BB;
      var x$2 = x$0.BB;
      return ((x === null) ? (x$2 === null) : x.f(x$2));
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 2;
});
$p.t = (function() {
  return "IncotermData";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.BA;
  }
  if ((n === 1)) {
    return this.BB;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "incoterm";
  }
  if ((n === 1)) {
    return "location";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lapp_data_IncotermData(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.jC)));
}
export { $isArrayOf_Lapp_data_IncotermData as $isArrayOf_Lapp_data_IncotermData };
var $d_Lapp_data_IncotermData = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_IncotermData, "app.data.IncotermData", ({
  jC: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lapp_data_IncotermData as $d_Lapp_data_IncotermData };
//# sourceMappingURL=app.data.-Incoterm-Data.js.map
